import { render, staticRenderFns } from "./BetSizeOptions.vue?vue&type=template&id=d893ed96&scoped=true&"
import script from "./BetSizeOptions.vue?vue&type=script&lang=ts&"
export * from "./BetSizeOptions.vue?vue&type=script&lang=ts&"
import style0 from "./BetSizeOptions.vue?vue&type=style&index=0&id=d893ed96&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d893ed96",
  null
  
)

export default component.exports